<template>
  <tbody>
    <template v-for="departamento in itens">
      <tr>
        <td class="pl-0 text-left">
          <v-btn
            icon
            @click.stop="departamento.expandido = !departamento.expandido"
          >
            <v-icon v-if="departamento.expandido">mdi-chevron-down</v-icon>
            <v-icon v-else>mdi-chevron-right</v-icon>
          </v-btn>
          {{ departamento.descricao_departamento }}

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="grey"
                dark
                v-bind="attrs"
                v-on="on"
                size="14"
                style="cursor: help"
              >
                mdi-information-outline
              </v-icon>
            </template>

            <div>
              <div>
                <span class="font-weight-medium">Projeção de vendas</span>:
                {{ Helpers.formatarValorComCasas(departamento.projecao_vendas, 2) }}
              </div>
              <div>
                <span class="font-weight-medium">Estoque atual</span>:
                {{ Helpers.formatarValorComCasas(departamento.estoque_atual, 2) }}
              </div>
              <div>
                <span class="font-weight-medium">Cobertura de estoque</span>:
                {{ Helpers.formatarValorComCasas(departamento.cobertura_instatanea, 2) + ' dias' }}
              </div>
            </div>
          </v-tooltip>
        </td>

        <td v-for="n in TOTAL_FORNECEDORES_PRECO_COMPRAS" :key="1+n" class="td-precos">
          <v-row class="ma-0" v-if="Object.keys(departamento.total_preco_compra).includes(n)">
            <v-checkbox
              v-model="checkbox_departamentos"
              multiple
              hide-details
              :ref="departamento.total_preco_compra[n].iddepartamento + departamento.total_preco_compra[n].idfornecedor"
              :value="JSON.stringify([
                departamento.total_preco_compra[n].iddepartamento,
                departamento.total_preco_compra[n].idfornecedor,
              ])"
              @click="atualizarCheckboxDepartamento"
              color="#FFFFFF"
              dense
            />

            <v-icon
              small
              :color="departamento.total_preco_compra[n].icon.color"
            >
              {{ departamento.total_preco_compra[n].icon.name }}
            </v-icon>

            <span class="pl-1 pt-1">{{ Helpers.formatarValor(departamento.total_preco_compra[n].dado) }}</span>
          </v-row>
          <v-row class="ma-0 text-center" v-else>
            <v-icon small class="mx-auto" color="gray">mdi-minus</v-icon>
          </v-row>
        </td>

        <td v-for="n in TOTAL_FORNECEDORES_PRECO_COMPRAS" :key="2+n" class="td-prazos">
          <v-row class="ma-0" v-if="Object.keys(departamento.total_prazo_entrega).includes(n)">
            <v-icon
              small
              :color="departamento.total_prazo_entrega[n].icon.color"
              class="ml-auto"
            >
              {{ departamento.total_prazo_entrega[n].icon.name }}
            </v-icon>

            <span class="mr-auto pl-1">
              {{ departamento.total_prazo_entrega[n].dado }} dias
            </span>
          </v-row>

          <v-row class="ma-0 text-center" v-else>
            <v-icon small class="mx-auto" color="gray">mdi-minus</v-icon>
          </v-row>
        </td>

        <td v-for="n in TOTAL_FORNECEDORES_PRECO_COMPRAS" :key="3+n" class="td-prazos">
          <v-row class="ma-0" v-if="Object.keys(departamento.total_prazo_pagamento).includes(n)">
            <v-icon
              small
              :color="departamento.total_prazo_pagamento[n].icon.color"
              class="ml-auto"
            >
              {{ departamento.total_prazo_pagamento[n].icon.name }}
            </v-icon>

            <span class="mr-auto pl-1">{{ departamento.total_prazo_pagamento[n].dado }} dias</span>
          </v-row>

          <v-row class="ma-0 text-center" v-else>
            <v-icon small class="mx-auto" color="gray">mdi-minus</v-icon>
          </v-row>
        </td>
      </tr>

      <tr
        v-show="departamento.expandido"
        v-for="(c, k) in departamento.categorias"
        :key="k"
      >
        <td class="pl-5 text-left text-truncate">
          <v-icon>mdi-circle-small</v-icon>
          {{ c.descricao_categoria }}

          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                color="grey"
                dark
                v-bind="attrs"
                v-on="on"
                size="14"
                style="cursor: help"
              >
                mdi-information-outline
              </v-icon>
            </template>

            <div>
              <div>
                <span class="font-weight-medium">Projeção de vendas</span>:
                {{ Helpers.formatarValorComCasas(c.projecao_vendas, 2) }}
              </div>
              <div>
                <span class="font-weight-medium">Estoque atual</span>:
                {{ Helpers.formatarValorComCasas(c.estoque_atual, 2) }}
              </div>
              <div>
                <span class="font-weight-medium">Cobertura de estoque</span>:
                {{ Helpers.formatarValorComCasas(c.cobertura_instatanea, 2) + ' dias' }}
              </div>
            </div>
          </v-tooltip>
        </td>

        <td v-for="n in TOTAL_FORNECEDORES_PRECO_COMPRAS" :key="1+n" class="td-precos">
          <v-row class="ma-0" v-if="Object.keys(c.preco_compra).includes(n)">
            <v-checkbox
              v-model="checkbox_categorias"
              multiple
              hide-details
              :value="JSON.stringify([
                c.preco_compra[n].iddepartamento,
                c.preco_compra[n].idfornecedor,
                c.preco_compra[n].idcategoria
              ])"
              :ref="c.preco_compra[n].iddepartamento + c.preco_compra[n].idfornecedor + c.preco_compra[n].idcategoria"
              @click="atualizarCheckboxCategoria"
              color="#FFFFFF"
              dense
              style="font-size: 10px"
            />

            <v-icon
              small
              :color="c.preco_compra[n].icon.color"
            >
              {{ c.preco_compra[n].icon.name }}
            </v-icon>

            <span class="pl-1">{{ c.preco_compra[n].dado }}</span>
          </v-row>

          <v-row class="ma-0 text-center" v-else>
            <v-icon small class="mx-auto" color="gray">mdi-minus</v-icon>
          </v-row>
        </td>

        <td v-for="n in TOTAL_FORNECEDORES_PRECO_COMPRAS" :key="2+n" class="td-prazos">
          <v-row class="ma-0" v-if="Object.keys(c.prazo_entrega).includes(n)">
            <v-icon
              small
              :color="c.prazo_entrega[n].icon.color"
              class="ml-auto"
            >
              {{ c.prazo_entrega[n].icon.name }}
            </v-icon>

            <span class="mr-auto pl-1">{{ c.prazo_entrega[n].dado }} dias</span>
          </v-row>

          <v-row class="ma-0 text-center" v-else>
            <v-icon small class="mx-auto" color="gray">mdi-minus</v-icon>
          </v-row>
        </td>

        <td v-for="n in TOTAL_FORNECEDORES_PRECO_COMPRAS" :key="3+n" class="td-prazos">
          <v-row class="ma-0" v-if="Object.keys(c.prazo_pagamento).includes(n)">
            <v-icon
              small
              :color="c.prazo_pagamento[n].icon.color"
              class="ml-auto"
            >
              {{ c.prazo_pagamento[n].icon.name }}
            </v-icon>

            <span class="mr-auto pl-1">{{ c.prazo_pagamento[n].dado }} dias</span>
          </v-row>

          <v-row class="ma-0 text-center" v-else>
            <v-icon small class="mx-auto" color="gray">mdi-minus</v-icon>
          </v-row>
        </td>
      </tr>
    </template>
  </tbody>
</template>

<script>
export default {
  name: 'TBody',
  props: {
    fornecedores: {
      type: Object,
      required: true
    },
    back_checkbox: {
      type: Object,
      required: true
    },
    itens: {
      type: Array,
      required: true
    },
    prop_categorias_checkbox: {
      type: Array
    }
  },
  data() {
    return {
      checkbox_departamentos: [],
      checkbox_categorias: [],
      check_cat_true: 0,
      check_total_cat_true: 0
    }
  },
  watch: {
    prop_categorias_checkbox(valor) {
      if (valor.length == this.checkbox_categorias.length) return;

      this.checkbox_categorias.filter(x => {
        if (!valor.includes(x)) {
          const parse = JSON.parse(x);

          this.checkbox_categorias = this.checkbox_categorias.filter(cc => cc != x);

          this.$refs[parse[0] + parse[1]][0].$children[0].$el.classList = 'v-icon notranslate v-icon--dense mdi mdi-minus-box theme--light';
          this.$refs[parse[0] + parse[1] + parse[2]][0].$el.parentElement.parentElement.classList = 'td-precos';
        }
      });

      const valor_map = valor.map(el => {
        const parse = JSON.parse(el);
        return JSON.stringify([parse[0], parse[1]]);
      });

      const unique = valor_map.filter((value, index, self) => self.indexOf(value) === index);

      this.checkbox_departamentos.forEach(el => {
        if (!unique.includes(el)) {
          const parse_el = JSON.parse(el);

          this.$refs[parse_el[0] + parse_el[1]][0].$el.offsetParent.classList = 'td-precos';
          this.$refs[parse_el[0] + parse_el[1]][0].$children[0].$el.classList = 'v-icon notranslate v-icon--dense mdi mdi-checkbox-blank-outline theme--light';
        }
      });

      this.checkbox_departamentos = unique;
    }
  },
  computed: {
    TOTAL_FORNECEDORES_PRECO_COMPRAS() {
      return this.fornecedores['Preco de compra'];
    },
    QTDE_CATEGORIAS () {
      return this.fornecedores['Preco de compra'].length;
    }
  },
  mounted() {
    Object.values(this.$refs).forEach(rf => {
      rf[0].$children[0].$el.style.fontSize = '13px';
    });
  },
  methods: {
    atualizarCheckboxDepartamento(evento) {
      const departamento_fornecedor = JSON.parse(evento.target.previousSibling._value);
      const categorias = this.back_checkbox[departamento_fornecedor[0]][departamento_fornecedor[1]];

      if (!evento.target.previousSibling.checked) {
        this.$refs[departamento_fornecedor[0]+departamento_fornecedor[1]][0].$el.offsetParent.classList = 'td-precos active-line-cotacao-departamento';
      } else {
        this.$refs[departamento_fornecedor[0]+departamento_fornecedor[1]][0].$el.offsetParent.classList = 'td-precos remove-line-cotacao-departamento';
      }

      Object.keys(categorias).forEach(cat => {
        const referencia = [
          departamento_fornecedor[0],
          departamento_fornecedor[1],
          Number(cat)
        ];

        const filtro = this.checkbox_categorias.findIndex(arr => arr == JSON.stringify(referencia));

        if (filtro == -1 && !evento.target.previousSibling.checked) {
          this.$refs[referencia[0] + referencia[1] + referencia[2]][0].$el.parentElement.parentElement.classList = 'td-precos active-line-cotacao-categoria';
          this.checkbox_categorias.push(JSON.stringify(referencia));
          return;
        }

        if (filtro >= 0 && evento.target.previousSibling.checked) {
          this.$refs[referencia[0] + referencia[1] + referencia[2]][0].$el.parentElement.parentElement.classList = 'td-precos remove-line-cotacao-categoria';
          this.checkbox_categorias.splice(filtro, 1);
        }
      });
      this.$emit('atualizar-categorias', this.checkbox_categorias);
    },
    atualizarCheckboxCategoria(evento) {
      const referencia = JSON.parse(evento.target.previousSibling._value);
      const departamento = referencia[0] + referencia[1];
      const filtro = this.prop_categorias_checkbox.findIndex(arr => {
        const parse_arr = arr;
        return parse_arr[0] == referencia[0] && parse_arr[1] == referencia[1] && parse_arr[2] == referencia[2]
      });

      this.check_total_cat_true = 0;
      this.check_cat_true = 0;

      setTimeout(() => {
        Object.keys(this.$refs).forEach(k => {
          if (k.includes(departamento) && k != departamento) ++this.check_total_cat_true;
          if (k.includes(departamento) && k != departamento && this.$refs[k][0].$refs.input.checked) ++this.check_cat_true;
        });

        if (this.$refs[departamento][0].$refs.input.checked) {
          if (this.check_cat_true == this.check_total_cat_true) {
            this.$refs[departamento][0].$children[0].$el.classList = 'v-icon notranslate v-icon--dense mdi mdi-checkbox-marked theme--light';
          } else {
            this.$refs[departamento][0].$el.offsetParent.classList = 'td-precos active-line-cotacao-departamento';
            this.$refs[departamento][0].$children[0].$el.classList = 'v-icon notranslate v-icon--dense mdi mdi-minus-box theme--light';
          }
        } else if (this.check_cat_true > 0){
          this.$refs[departamento][0].$children[0].$el.classList = 'v-icon notranslate v-icon--dense mdi mdi-minus-box theme--dark';
          this.$refs[departamento][0].$el.offsetParent.classList = 'td-precos active-line-cotacao-departamento';
        } else {
          this.$refs[departamento][0].$el.offsetParent.classList = 'td-precos';
          this.$refs[departamento][0].$children[0].$el.classList = 'v-icon notranslate v-icon--dense mdi mdi-checkbox-blank-outline theme--light';
        }
      }, 300);

      if (filtro == -1 && !evento.target.previousSibling.checked) {
        const dep = JSON.stringify([referencia[0], referencia[1]]);
        this.checkbox_departamentos.push(dep);
        this.$refs[departamento + referencia[2]][0].$el.offsetParent.classList = 'td-precos active-line-cotacao-categoria';
      }

      if (evento.target.previousSibling.checked) {
        this.checkbox_departamentos = this.checkbox_departamentos.filter(fcd => fcd != JSON.stringify([referencia[0], referencia[1]]));
        this.$refs[departamento + referencia[2]][0].$el.parentElement.parentElement.classList.value = 'td-precos';
      }

      this.$emit('atualizar-categorias', this.checkbox_categorias);
    }
  }
}
</script>

<style scoped>
.no-border {
  border: none !important
}

.active-line-cotacao-departamento {
  background-color: #043554 !important;
  color: white;
}

.remove-line-cotacao-departamento {
  background-color: #FFF !important;
  color: #000;
}

.active-line-cotacao-categoria {
  background-color: #507288 !important;
  color: white;
}

.remove-line-cotacao-categoria {
  background-color: #FFF !important;
  color: #000;
}

th {
  font-size: 10pt;
  text-align: center;
  border: 1px solid #797878 !important;
  height: 40px;
}
td {
  font-size: 10pt;
  text-align: center;
  border: 1px solid #797878 !important;
  height: 40px;
}
.td-precos {
  min-width: 130px !important;
  max-width: 130px !important;
}

.td-prazos {
  min-width: 100px !important;
  max-width: 100px !important;
}
</style>
